module.exports = __webpack_public_path__ + "static/media/change-survey-status-icon.cc507d25.svg";